// API AD people requests configuration file
import axios from "axios"

export default axios.create({
  baseURL: process.env.REACT_APP_PEOPLEPICKER_URI,
  headers: {
    "Content-type": "application/json",
  },
})
